export default {
    fields: [
        // 基本信息
        {
            canSelect: false,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            id: "baoliqiuji00000001308",
            inputLength: 111,
            keyword: "name",
            name: "姓名",
            nameEn: 'Name',
            placeholder: "请输入您的姓名",
            placeholderEn: 'Name',
            required: true,
            step: 1,
            subjectType: "VISITOR",
        },
        {
            canSelect: true,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 0,
            id: "baoliqiuji0000000137",
            inputLength: null,
            keyword: "countryName",
            name: "国家",
            nameEn: 'Nationality',
            placeholder: "请选择",
            placeholderEn: 'Nationality',
            required: true,
            showType: "perfectInformation",
            step: 1,
            subjectType: "VISITOR",
        },
        // {
        //     canSelect: true,
        //     editable: true,
        //     exhibitionId: "256cef9c35b34141a93a1a5174df6458",
        //     height: 100,
        //     id: "baoliqiuji00000001101",
        //     inputLength: 100,
        //     keyword: "idType",
        //     name: "证件类型",
        //     nameEn: 'ID Document Type',
        //     placeholder: "证件类型",
        //     placeholderEn: "ID Document Type",
        //     required: true,
        //     showType: "perfectInformation",
        //     step: 1,
        //     subjectType: "VISITOR",
        // },
        // {
        //     canSelect: false,
        //     editable: true,
        //     exhibitionId: "256cef9c35b34141a93a1a5174df6458",
        //     height: 100,
        //     id: "baoliqiuji00000001141",
        //     inputLength: 100,
        //     keyword: "idImage",
        //     name: "证件照片",
        //     nameEn: "Passport photo",
        //     placeholder: "",
        //     placeholderEn: "Passport photo",
        //     required: false,
        //     showType: "perfectInformation",
        //     step: 2,
        //     subjectType: "VISITOR"
        // },
        // {
        //     canSelect: false,
        //     editable: true,
        //     height: 0,
        //     inputLength: null,
        //     keyword: "post",
        //     name: "职位",
        //     nameEn: "Postion",
        //     placeholder: "职务",
        //     placeholderEn: "Postion",
        //     required: true,
        //     showType: "perfectInformation",
        //     step: 1,
        //     subjectType: "VISITOR",
        // },
        {
            canSelect: false,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 0,
            id: "baoliqiuji0000000139",
            inputLength: null,
            keyword: "email",
            name: "邮箱",
            nameEn: "E-mail",
            placeholder: "邮箱",
            placeholderEn: "E-mail",
            required: true,
            showType: "perfectInformation",
            step: 1,
            subjectType: "VISITOR",
        },
        {
            canSelect: false,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 100,
            id: "baoliqiuji00000001317",
            inputLength: 11,
            keyword: "mobile",
            name: "手机",
            nameEn: "Mobile",
            placeholder: "手机号码",
            placeholderEn: "Mobile",
            required: false,
            showType: "perfectInformation",
            step: 1,
            subjectType: "VISITOR",
        },
        // {
        //     canSelect: true,
        //     editable: true,
        //     exhibitionId: "256cef9c35b34141a93a1a5174df6458",
        //     height: 0,
        //     id: "baoliqiuji000000013766",
        //     inputLength: null,
        //     keyword: "socialMedia",
        //     name: "社交媒体",
        //     nameEn: "Soclal media you use most frequently",
        //     placeholder: "社交媒体",
        //     placeholderEn: "Soclal media you use most frequently",
        //     required: false,
        //     showType: "perfectInformation",
        //     step: 1,
        //     subjectType: "VISITOR",
        // },
        // {
        //     canSelect: false,
        //     editable: true,
        //     exhibitionId: "256cef9c35b34141a93a1a5174df6458",
        //     height: 0,
        //     id: "baoliqiuji00000001301",
        //     inputLength: null,
        //     keyword: "headImage",
        //     name: "头像",
        //     nameEn: "Photo",
        //     placeholder: "头像",
        //     placeholderEn: "Photo",
        //     required: false,
        //     showType: "perfectInformation",
        //     step: 2,
        //     subjectType: "VISITOR"
        // },
        // 公司信息
        {
            canSelect: false,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 0,
            id: "baoliqiuji00000001390",
            inputLength: null,
            keyword: "corporateName",
            name: "公司名称",
            nameEn: "Company Name",
            placeholder: "请输入您的公司名称",
            placeholderEn: "Company Name",
            required: true,
            showType: "perfectInformation",
            step: 2,
            subjectType: "VISITOR",
        },
        // {
        //     canSelect: true,
        //     editable: true,
        //     exhibitionId: "256cef9c35b34141a93a1a5174df6458",
        //     height: 0,
        //     id: "baoliqiuji000000013755",
        //     inputLength: null,
        //     keyword: "corporateCountryName",
        //     name: "公司所在国",
        //     nameEn: "Company Country/Region",
        //     placeholder: "公司所在国",
        //     placeholderEn: "Company Country/Region",
        //     required: true,
        //     showType: "perfectInformation",
        //     step: 1,
        //     subjectType: "VISITOR",
        // },
        // {
        //     canSelect: false,
        //     editable: true,
        //     exhibitionId: "256cef9c35b34141a93a1a5174df6458",
        //     height: 100,
        //     id: "baoliqiuji0000000186",
        //     inputLength: 100,
        //     keyword: "brand",
        //     name: "品牌",
        //     nameEn: "Brand",
        //     placeholder: "品牌",
        //     placeholderEn: "Brand",
        //     required: false,
        //     showType: "perfectInformation",
        //     step: 2,
        //     subjectType: "VISITOR"
        // },
        // {
        //     canSelect: false,
        //     editable: true,
        //     exhibitionId: "256cef9c35b34141a93a1a5174df6458",
        //     height: 100,
        //     id: "baoliqiuji0000000193",
        //     inputLength: 100,
        //     keyword: "website",
        //     name: "公司网址",
        //     nameEn: "Company Website",
        //     placeholder: "公司网址",
        //     placeholderEn: "Company Website",
        //     required: false,
        //     showType: "perfectInformation",
        //     step: 2,
        //     subjectType: "VISITOR"
        // },
        {
            canSelect: false,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 0,
            id: "baoliqiuji00000001212",
            inputLength: null,
            keyword: "address",
            name: "公司地址",
            nameEn: "Company Address",
            placeholder: "请输入您的公司地址",
            placeholderEn: "Company Address",
            required: false,
            showType: "perfectInformation",
            step: 2,
            subjectType: "VISITOR"
        },
        {
            canSelect: false,
            editable: true,
            exhibitionId: "256cef9c35b34141a93a1a5174df6458",
            height: 0,
            id: "baoliqiuji00000001279",
            inputLength: null,
            keyword: "telephone",
            name: "公司电话",
            nameEn: "Company Tel",
            placeholder: "公司电话",
            placeholderEn: "Company Tel",
            required: true,
            showType: "perfectInformation",
            step: 2,
            subjectType: "VISITOR",
        },
        // {
        //     canSelect: false,
        //     editable: true,
        //     exhibitionId: "256cef9c35b34141a93a1a5174df6458",
        //     height: 100,
        //     id: "baoliqiuji0000000197",
        //     inputLength: 100,
        //     keyword: "fax",
        //     name: "公司传真",
        //     nameEn: "Company Fax",
        //     placeholder: "公司传真",
        //     placeholderEn: "Company Fax",
        //     required: false,
        //     showType: "perfectInformation",
        //     step: 2,
        //     subjectType: "VISITOR"
        // }
    ]
}